import { type PropsWithChildren, type ReactNode } from "react";

import { T } from "@repo/transifex";
import { Button, type ButtonProps, Dialog } from "~/components";

import { TerminalReadyIcon } from "./TerminalReadyIcon";

type CardPaymentDialogProps = PropsWithChildren<{
  /** Optional title shown at the top of the dialog */
  title?: ReactNode;
  /** Optional description or amount text under the title */
  description?: ReactNode;
  /** Optional custom illustration/icon. Defaults to `TerminalReadyIcon`. */
  icon?: ReactNode;
}>;

const CardPaymentDialog = ({
  title,
  description,
  icon,
  children
}: CardPaymentDialogProps) => {
  return (
    <Dialog className="max-w-sm" size="md">
      <div className="flex flex-col items-center gap-y-5 p-5">
        <div className="flex w-full flex-col items-center gap-5 rounded-2xl bg-background-secondary p-5">
          {title ? (
            <p className="text-lg font-bold text-primary-light">{title}</p>
          ) : null}
          {description ? (
            <p className="text-2xl font-bold">{description}</p>
          ) : null}

          {icon ?? <TerminalReadyIcon />}
        </div>

        {children}
      </div>
    </Dialog>
  );
};

const CancelButton = (props: ButtonProps) => {
  return (
    <Button {...props} variant="danger">
      <T _str="Cancel" />
    </Button>
  );
};

CardPaymentDialog.CancelButton = CancelButton;

export { CardPaymentDialog };
